module.exports = __webpack_public_path__ + "static/pod-become-inactive-83da68ffe58511b95e2d93c444542d18.jpg";